import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoutGuardService implements CanActivate {

  constructor(private router: Router, private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if(this.auth.isUserLoggedIn()){
      if (route.data.roles && route.data.roles == 2 && (this.auth.getIsAdmin() || this.auth.getIsSupervisor()))
        return true
      else if (route.data.roles && route.data.roles == 3 && (this.auth.getIsAdmin()))
        return true;
      else if (route.data.roles && route.data.roles >= 2 && (this.auth.getIsAdmin() == false && this.auth.getIsSupervisor() == false)) 
       return false;
      else
        return true;
    } else{
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
    }   
  }
}
